module.exports = __webpack_public_path__ + "static/media/inner_window.966324d8.svg";